import { put, takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import { GetIsAuthenticatedActionTypes, LoginActionTypes, LogoutActionTypes } from './types';
import { getIsAuthenticatedActions, loginActions, logoutActions } from './actions';
import sagaUtility from '../../blocks/utils/saga-utility';
import { LoginRequest } from '../../models/auth/login/LoginRequest';
import AuthService from '../../services/auth.service';
import Toast from '../../components/shared/Toast';
import I18n from 'i18n-js';
import { getAccountActions, verifyEmailActions } from '../account/actions';
import RoutesConst from '../../blocks/consts/RoutesConst';
import { push } from 'connected-react-router';
import SessionStorageConst from '../../blocks/consts/SessionStorageConst';
import ErrorMessage from '../../models/ErrorMessage';

export default function* authSaga() {
    yield takeEvery(LoginActionTypes.REQUEST, loginRequest);
    yield takeEvery(LoginActionTypes.SUCCESS, loginSuccess);
    yield takeEvery(LoginActionTypes.ERROR, loginError);

    yield takeEvery(LogoutActionTypes.REQUEST, logoutRequest);
    yield takeEvery(LogoutActionTypes.SUCCESS, logoutSuccess);

    yield takeEvery(GetIsAuthenticatedActionTypes.REQUEST, getIsAuthenticatedRequest);
    yield takeEvery(GetIsAuthenticatedActionTypes.SUCCESS, getIsAuthenticatedSuccess);
    yield takeEvery(GetIsAuthenticatedActionTypes.ERROR, getIsAuthenticatedError);
}

function* loginRequest(action: Action<LoginRequest>) {
    yield sagaUtility(action.payload, AuthService.login, loginActions.success, loginActions.failure, true);
}

function* loginSuccess(action: Action<any>) {
    Toast.notifySuccess(I18n.t('login.success'));
    sessionStorage.setItem(SessionStorageConst.IsAuthenticated, "true");
    yield put(push(RoutesConst.Dashboard));
}

function* loginError(action: Action<any>) {
    const request = action.payload.request as LoginRequest;
    const errorMessages = action.payload.error as ErrorMessage[];

    if (errorMessages.length === 2) {
        const code = errorMessages[0];
        const error = errorMessages[1];

        if (error.code === 'Verify.Email') {
            yield put(verifyEmailActions.request({ email: request.username, code: code.message }));
        }
    }
}

function* logoutRequest(action: Action<any>) {
    yield sagaUtility(action.payload, AuthService.logout, logoutActions.success, logoutActions.failure);
}

function* logoutSuccess(action: Action<any>) {
    Toast.notifySuccess(I18n.t('logout.success'));
    sessionStorage.removeItem(SessionStorageConst.IsAuthenticated);
    yield put(push(RoutesConst.Login));
}

function* getIsAuthenticatedRequest(action: Action<any>) {
    yield sagaUtility(action.payload, AuthService.isAuthenticated, getIsAuthenticatedActions.success, getIsAuthenticatedActions.failure);
}

function* getIsAuthenticatedSuccess(action: Action<any>) {
    sessionStorage.setItem(SessionStorageConst.IsAuthenticated, "true");
    yield put(getAccountActions.request());
}

function* getIsAuthenticatedError(action: Action<any>) {
    sessionStorage.removeItem(SessionStorageConst.IsAuthenticated);
    yield put(push(RoutesConst.Login));
}
